import axios from 'axios'

/**
 * 游戏配置：从后端 /api/game/war/games 下发，
 * 包含每个游戏的 gameId/code/name/icon/modifyTypes/supportRank/wxMondayOnly/timeRule。
 * 前端不写死任何游戏差异。
 *
 * 不做跨页面缓存：游戏文案/规则在后台随时可改，缓存会让页面一直显示旧配置
 * （SPA 内路由返回、HMR 热更新都不会重新求值模块，旧值会一直粘住）。
 * 这里只对「同一时刻并发的重复请求」去重，避免多个组件各发一次。
 */
let inflight = null

export function loadGames() {
  if (inflight) {
    return inflight
  }
  inflight = axios.get('/api/game/war/games').then((response) => {
    inflight = null
    if (response.data && response.data.code === '0000') {
      return response.data.data || []
    }
    return []
  }, (error) => {
    inflight = null
    throw error
  })
  return inflight
}

/**
 * 游戏图标:优先取前端打包的本地切图(assets/icons/game-{code}.png),
 * 没有对应切图时回退后端配置的 icon 路径。
 */
export function gameIcon(game) {
  if (!game) {
    return '';
  }
  try {
    return require(`@/assets/icons/game-${game.code}.png`);
  } catch (e) {
    return game.icon || '';
  }
}

export function findGame(games, key) {
  if (key === undefined || key === null || key === '') {
    return null
  }
  return games.find(g => g.code === key || String(g.gameId) === String(key)) || null
}
